(function($) {
    $(document).ready(function() {
        $('.carrousel__container').on('carrousel:initialized', function(event) {
            $(this).attr('aria-live', 'polite');

            var timer = setInterval(function() {
                $('.js-carrousel__button__next button').trigger('click');
            }, 20000);

            var pause = $('<button class="carrousel__pause"></button>');
            $('.carrousel').prepend(pause);
            pause.on('click', function(event) {
                event.preventDefault();
                clearInterval(timer);
                pause.remove();
                $(this).removeAttr('aria-live');
            });
            $(window).scroll(function() {
                clearInterval(timer);
                pause.remove();
                $(this).removeAttr('aria-live');
            });
        });;
    });
})(jQuery);